import { styled, theme } from "@theme/stitches.config"
// eslint-disable-next-line import/no-unresolved
import { Swiper } from "swiper/react"

export const SlidingTextWrapper = styled("div", {
    mt: 130,
    pointerEvents: "none",
    userSelect: "none",
    "@mdDown": {
        mt: 60
    }
})

export const StyledSwiper = styled(Swiper, {
    "& .swiper-wrapper": {
        transitionTimingFunction: "linear !important"
    },
    "& .swiper-slide": {
        display: "flex",
        alignItems: "center",
        width: "auto"
    }
})

export const Content = styled("p", {
    fontSizePxToRem: 200,
    fontFamily: theme.fonts.heading,
    lineHeight: 1.2,
    color: "transparent",
    WebkitTextStroke: "3px #454F66",
    textTransform: "uppercase",
    "@mdDown": {
        fontSizePxToRem: 100
    }
})
